import { PluginConfigs } from '../../plugin-configs';
import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the Nielsen Plugin.
 *
 * @remarks
 * The plugin is enabled via the remote configuration for applicable clients.
 *
 * Be aware that most of the parameters are required by the plugin, so if some values are missing,
 * the plugin will not work as expected and should be disabled.
 */
export const addNielsenPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs) => {
  const nielsen = 'foundation.plugin.nielsen';
  const { remoteConfig } = partialBuilderConfig;

  const enabled =
    typeof pluginConfigs[nielsen]?.enabled === 'boolean'
      ? pluginConfigs[nielsen].enabled
      : remoteConfig.nielsen?.enable;

  if (!enabled) {
    return pluginConfigs;
  }

  const config = {
    endpoint: remoteConfig.nielsen?.endpoint,
    appId:
      typeof remoteConfig.nielsen?.apid === 'string' ? remoteConfig.nielsen.apid : remoteConfig.nielsen?.apid?.default,
    clientId: remoteConfig.nielsen?.clientId,
    debug: remoteConfig.nielsen?.debug,
    ...pluginConfigs[nielsen],
    enabled,
  };

  if (!config.endpoint || !config.appId || !config.clientId) {
    // eslint-disable-next-line no-console
    console.warn('Could not activate Nielsen Tracking because of invalid parameters.', config);
    return pluginConfigs;
  }

  return {
    ...pluginConfigs,
    [nielsen]: config as PluginConfigs['foundation.plugin.nielsen'],
  };
};
